import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {YoutubeEmbed, VimeoEmbed, FacebookEmbed} from '../../../../../components/video';
import VideoForm from '../../../../../components/forms/video';

import {paletteData, Button, Typography, Dialog} from '../../../../../components/styles';
import {GridContainer, GridCell} from '../../../../../components/grid';

function EditCategoryCoreSubPanel({
    focusedCategory,
    handleChangeFocusedCategory,
    processing,
    setProcessing,
  }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(undefined);

  return (
    <div>
      <div style={{background: paletteData.primary.standard.background, padding: 10}}>
        <GridContainer>
          <GridCell weight={1}>
            <Typography style={{color: paletteData.primary.standard.foreground}}>
              Video Library
            </Typography>
          </GridCell>
          <GridCell>
            <Button
              palette="secondary" size='small'
              onClick={() => {
                setDialogOpen(true);
                setDialogData({
                  type: 'addVideo',
                  title: 'Add a video to your library',
                  preview: undefined,
                  value: {
                    platform: 'youtube',
                    link: '',
                    title: '',
                    tags: '',
                    description: '',
                  }
                });
              }}
            >
              Add video
            </Button>
          </GridCell>
        </GridContainer>
      </div>
      {(!focusedCategory.videoLibrary || focusedCategory.videoLibrary.length === 0) &&
        <div style={{margin: 5}}>
          <Typography>
            Library empty
          </Typography>
        </div>
      }
      {focusedCategory.videoLibrary?.length > 0 &&
        <div style={{margin: 5}}>
          {focusedCategory.videoLibrary.map((v, vIndex) => (
            <div key={vIndex}>
              <GridContainer>
                <GridCell weight={1} style={{padding: 10}}>
                  {v.platform === 'youtube' &&
                    <YoutubeEmbed youtubeId={v.youtubeId} />
                  }
                  {v.platform === 'vimeo' &&
                    <VimeoEmbed vimeoId={v.vimeoId}/>
                  }
                  {v.platform === 'facebook' &&
                    <FacebookEmbed title={v.title} link={v.link} credit={v.credit} citation={v.citation} />
                  }
                </GridCell>
                <GridCell weight={2} style={{padding: 10}}>
                  <Typography size='title'>
                    {v.title}
                  </Typography>
                  <Typography style={{color: '#c6c6c6'}}>
                    {v.tags}
                  </Typography>
                  <br/>
                  <Typography style={{whiteSpace: 'pre-wrap'}}>
                    {v.description}
                  </Typography>
                </GridCell>
              </GridContainer>
              <Button
                palette='primary'
                onClick={() => {
                  setDialogData({
                    type: 'editVideo',
                    title: 'Edit a video in your library',
                    index: vIndex,
                    value: {
                      ...v,
                      link: `https://www.youtube.com/watch?v=${v.youtubeId}`,
                    }
                  });
                  setDialogOpen(true);
                }}
              >
                Edit Video
              </Button>
            </div>
          ))}
        </div>
      }

      {/*popouts and popups*/}
      {dialogOpen &&
        <Dialog open={dialogOpen} handleClose={() => setDialogOpen(false)}>
          <div style={{padding: 10, textAlign: 'center', background: paletteData.primary.standard.background}}>
            <Typography size='title' style={{color: paletteData.primary.standard.foreground}}>
              {dialogData?.title}
            </Typography>
          </div>
          {(dialogData?.message) &&
            <div style={{padding: 10}}>
              <Typography>
                {dialogData.message}
              </Typography>
            </div>
          }
          {(dialogData?.type === 'addVideo' || dialogData?.type === 'editVideo') &&
            <div style={{padding: 10}}>
              <VideoForm
                video={dialogData?.value || {}}
                handleChange={(name, value) => {
                  const dialogDataProcessed = {
                    ...dialogData,
                    value: {
                      ...(dialogData?.value || {}),
                      [name]: value,
                    }
                  };
                  setDialogData(dialogDataProcessed);
                }}
              />
            </div>
          }

          <GridContainer>
            <GridCell weight={1}/>
            <GridCell style={{padding: 10}}>
              <Button
                palette='primary'
                 onClick={() => {
                  setDialogOpen(false);
                  setDialogData(undefined);
                }}
              >
                {dialogData?.type === 'message' ? 'OK' : 'Cancel'}
              </Button>
            </GridCell>
            {dialogData?.type === 'addVideo' &&
              <GridCell style={{padding: 10}}>
                <Button
                  disabled={processing}
                  palette='primary'
                  onClick={() => {
                    const item = {
                      platform: dialogData?.value?.platform,
                      link: dialogData?.value?.link,
                      title: dialogData?.value?.title,
                      credit:  dialogData?.value?.credit,
                      citation: dialogData?.value?.citation,
                      tags: dialogData?.value?.tags,
                      description: dialogData?.value?.description,
                    };
                    if(item.platform === 'youtube') {
                      item.youtubeId = (dialogData?.value?.link || '').replace('https://www.youtube.com/watch?v=', '');
                    }
                    if(item.platform === 'vimeo') {
                      item.vimeoId = (dialogData?.value?.link || '').replace('https://vimeo.com/', '');
                    }
                    const videoLibraryProcessed = focusedCategory.videoLibrary || [];
                    videoLibraryProcessed.push(item);
                    handleChangeFocusedCategory('videoLibrary', videoLibraryProcessed);
                    setDialogData(undefined);
                    setDialogOpen(false);
                  }}
                >
                  Add Video
                </Button>
              </GridCell>
            }
            {dialogData?.type === 'editVideo' &&
              <GridCell style={{padding: 10}}>
                <Button
                  disabled={processing}
                  palette='primary'
                  onClick={() => {
                    const videoLibraryProcessed = focusedCategory.videoLibrary || [];
                    videoLibraryProcessed.splice(dialogData?.index, 1);
                    handleChangeFocusedCategory('videoLibrary', videoLibraryProcessed);
                    setDialogData(undefined);
                    setDialogOpen(false);
                  }}
                >
                  Delete Video
                </Button>
              </GridCell>
            }
            {dialogData?.type === 'editVideo' &&
              <GridCell style={{padding: 10}}>
                <Button
                  disabled={processing}
                  palette='primary'
                  onClick={() => {
                    const item = {
                      platform: dialogData?.value?.platform,
                      link: dialogData?.value?.link,
                      title: dialogData?.value?.title,
                      credit:  dialogData?.value?.credit,
                      citation: dialogData?.value?.citation,
                      tags: dialogData?.value?.tags,
                      description: dialogData?.value?.description,
                    };
                    if(item.platform === 'youtube') {
                      item.youtubeId = (dialogData?.value?.link || '').replace('https://www.youtube.com/watch?v=', '');
                    }
                    if(item.platform === 'vimeo') {
                      item.vimeoId = (dialogData?.value?.link || '').replace('https://vimeo.com/', '');
                    }
                    const videoLibraryProcessed = focusedCategory.videoLibrary || [];
                    videoLibraryProcessed.splice(dialogData?.index, 1, item);
                    handleChangeFocusedCategory('videoLibrary', videoLibraryProcessed);
                    setDialogData(undefined);
                    setDialogOpen(false);
                  }}
                >
                  Edit Video
                </Button>
              </GridCell>
            }
          </GridContainer>
        </Dialog>
      }
    </div>
  );
};

EditCategoryCoreSubPanel.propTypes = {
  focusedCategory: PropTypes.shape({}),
  handleChangeFocusedCategory: PropTypes.func,
  processing: PropTypes.bool,
  setProcessing: PropTypes.func,
};

export default EditCategoryCoreSubPanel;
